import TextFieldAdapter, { TextFieldAdapterProps } from './TextFieldAdapter';
import { fixedLength } from '../helper/validators';

export const ZipCodeFieldAdapter = (props: Omit<TextFieldAdapterProps, 'mask'>) => {
  return <TextFieldAdapter {...props} mask="00000" validators={[fixedLength(5)]} />;
};
